// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-bordered[data-v-6bd84b8a] {\n  padding: 1em;\n  border: 1px solid #cacaca;\n  border-radius: 0.3em;\n}\n.table-bordered table.table[data-v-6bd84b8a] {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
